// Sticky Side filter in listing page - Only runs on collection pages
$(document).ready(function() {
    // Check if we're on a collection page
    if (document.body.classList.contains('template-collection') || 
        window.location.pathname.includes('/collections/') ||
        document.querySelector('.main-collection-grid')) {
        
        var $stickyElement = $('.facets-block-wrapper--vertical,.facets-toggle');
        var $container = $('.main-collection-grid');
        
        // Only proceed if the required elements exist
        if ($stickyElement.length && $container.length) {
            var stickyTop = $stickyElement.offset().top;
            
            $(window).scroll(function() {
                var windowTop = $(window).scrollTop();
                var containerBottom = $container.offset().top + $container.outerHeight();
                var stickyHeight = $stickyElement.outerHeight();
                
                // Check if we should stick
                if (windowTop > stickyTop) {
                    // Check if sticky element would go beyond container
                    if ((windowTop + stickyHeight) > containerBottom) {
                        // Stop sticky - position at container bottom
                        $stickyElement.css({
                            'position': 'absolute',
                            'top': containerBottom - stickyHeight - $container.offset().top,
                            'bottom': 'auto'
                        });
                    } else {
                        // Make sticky
                        $stickyElement.css({
                            'position': 'fixed',
                            'top': '0',
                            'bottom': 'auto'
                        });
                    }
                } else {
                    // Return to normal position
                    $stickyElement.css({
                        'position': 'relative',
                        'top': 'auto',
                        'bottom': 'auto'
                    });
                }
            });
        }
    }
});

// Force Simply Southern Kids tab to navigate to the correct tagged URL,
// and block any other handlers on that tab from redirecting to /collections/youth.
$(document).ready(function() {
    if (window.location.pathname.indexOf('/collections/simply-southern') !== 0) {
        return;
    }

    function wireSimplySouthernKidsTab() {
        // Try to find the Kids tab within the Simply Southern navigation
        var candidates = document.querySelectorAll('a, button');
        var kidsTab = null;

        candidates.forEach(function(el) {
            if (kidsTab) return;
            var text = (el.textContent || '').trim().toLowerCase();
            if (text === 'kids') {
                kidsTab = el;
            }
        });

        if (!kidsTab || kidsTab.__ssKidsWired) {
            return;
        }

        kidsTab.__ssKidsWired = true;
        var targetUrl = '/collections/simply-southern/Gender:Youth';

        if (kidsTab.tagName === 'A') {
            kidsTab.href = targetUrl;
        }

        console.log('[SS Kids Debug] Wiring Simply Southern Kids tab override', kidsTab);

        // Use capture phase and stopImmediatePropagation so other handlers (e.g. Searchspring)
        // cannot override this navigation.
        kidsTab.addEventListener('click', function(e) {
            console.log('[SS Kids Debug] Kids tab clicked, forcing URL:', targetUrl);
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();
            window.location.href = targetUrl;
        }, true);
    }

    // Run once after DOM ready
    wireSimplySouthernKidsTab();

    // Also observe DOM changes because the tabs may be rendered/updated dynamically
    var observer = new MutationObserver(function() {
        wireSimplySouthernKidsTab();
    });
    observer.observe(document.body, { childList: true, subtree: true });
});


// Global promo message handling (runs on all pages)
// Global promo message handling (runs on all pages including product detail pages)
$(document).ready(function() {
    const gridItems = $('.group-block-content > .promo-message-block');
    
    gridItems.each(function(index, item) {
      const $item = $(item);
      // Check if content is empty or only whitespace
      if (!$item.text().trim() && $item.children().length === 0) {
        $item.addClass('empty-item');
      }
    });
  });


// Category slider 
 

// Watch for ss__autocomplete--active class on body and add class to header-menu__inner
$(document).ready(function() {
    var headerMenuInner = $('.header-menu__inner');
    
    if (headerMenuInner.length) {
        // Function to check and update class
        function updateHeaderMenuClass() {
            if ($('body').hasClass('ss__autocomplete--active')) {
                headerMenuInner.addClass('autocomplete-active');
            } else {
                headerMenuInner.removeClass('autocomplete-active');
            }
        }
        
        // Check initially
        updateHeaderMenuClass();
        
        // Watch for class changes on body element using MutationObserver
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    updateHeaderMenuClass();
                }
            });
        });
        
        // Start observing the body element
        observer.observe(document.body, {
            attributes: true,
            attributeFilter: ['class']
        });
    }
});

